import { Component, OnInit} from '@angular/core';
import { trigger, style, animate, transition } from '@angular/animations';
import { SwUpdate } from '@angular/service-worker';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  animations: [   
    trigger('routeAnimations', [
      transition('* => Main', [
        style({ transform: 'translateX(-100%)' }),
        animate('500ms ease-in', style({ transform: 'translateX(0%)' }))
      ]),
      transition('* => Landing', [
        style({ transform: 'translateX(-100%)' }),
        animate('500ms ease-in', style({ transform: 'translateX(0%)' }))
      ]),
      transition('* => Agreement', [
        style({ transform: 'translateX(-100%)' }),
        animate('500ms ease-in', style({ transform: 'translateX(0%)' }))
      ]),         
    ])
  ],
})
export class AppComponent implements OnInit {
  title = 'monex-customer-portal';

  constructor(private swUpdate: SwUpdate) {
  }

  ngOnInit() {}
}
